/**
 * Placeholder kartu produk saat data penuh (gambar + harga) belum dihidrasi.
 * Dimensi mengikuti `HomeProductCard` agar tidak ada layout shift. `size="rail"`
 * menyamai lebar kartu rail. `productId` (feed beranda) menandai sel dengan
 * `data-product-id` yang sama seperti kartunya, supaya jangkar memori posisi
 * beranda tetap ditemukan walau kartunya belum terhidrasi. `listAnchor` sama
 * untuk memori posisi daftar (`AdminListMemory`) — kerangka ikut membawa
 * jangkar kartunya selama hidrasi.
 */
export function HomeProductCardSkeleton({
  size = "grid",
  productId,
  listAnchor
}: {
  size?: "grid" | "rail";
  productId?: string;
  listAnchor?: string;
}) {
  return (
    <div
      data-product-id={productId}
      data-list-anchor={listAnchor}
      className={`overflow-hidden rounded-md bg-white shadow-sm ${
        size === "rail" ? "w-36 shrink-0 snap-start" : ""
      }`}
    >
      <div className="aspect-square animate-pulse bg-neutral-200" />
      <div className="space-y-2 p-2">
        <div className="h-3 w-full animate-pulse rounded bg-neutral-200" />
        <div className="h-3 w-2/3 animate-pulse rounded bg-neutral-200" />
        <div className="h-4 w-1/2 animate-pulse rounded bg-neutral-200" />
      </div>
    </div>
  );
}
